import React from 'react';
import DatePicker from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.css';

// CSS in JS
const datePickerStyles = `
  .react-datepicker {
    background-color: var(--bg-surface-2);
    border: 1px solid #192735;
    z-index: 10;
  }

  .react-datepicker-ignore-onclickoutside {
    background-color: var(--bg-surface) !important;
    border: 1px solid var(--border-light) !important;
    color: var(--text-main);
    border-radius: 0.75rem;
    box-shadow: var(--shadow-card);
  }
  
  .react-datepicker__current-month,
  .react-datepicker-time__header,
  .react-datepicker-year-header {
    color: var(--text-main);
  }

  .react-datepicker-wrapper {
    width: 100%;
  }

  .react-datepicker__input-container > input {
    background-color: var(--bg-surface) !important;
    border: 1px solid var(--border-light) !important; 
    color: var(--text-main);
    padding-left: 1rem;
    padding-right: 1rem;
    border-radius: 0.75rem;
    cursor: pointer;
    width: 100%;
    height: 3rem;
    margin-bottom: 0px;
  }

  .react-datepicker__input-container {
    margin-bottom: 0px;
  }

  .react-datepicker__input-container > input:focus {
    --tw-ring-color: '#FFF !important';
  }

  .react-datepicker__input-container > input::placeholder {
    color: var(--text-muted);
    opacity: 1;
    font-size: inherit;
  }
  
  .react-datepicker-popper {
    background-color: var(--bg-surface);
  }
  
  .react-datepicker__triangle {
    display: none !important;
  }
  
  .react-datepicker__navigation-icon::before {
    border-color: var(--text-muted);
  }
  
  .react-datepicker__header {
    background-color: var(--bg-surface-2);
  }
  
  .react-datepicker__current-month {
    color: var(--text-main);
    margin-bottom: 10px;
  }
  
  .react-datepicker__header__dropdown {
    display: block !important;
  }
  
  .react-datepicker__header__dropdown {
    color: var(--text-main);
  }
  
  .react-datepicker__day-name {
    color: var(--text-main);
  }
  
  .react-datepicker__day--disabled {
    opacity: 0.4;
  }
  
  .react-datepicker__day {
    color: var(--text-main);
  }
  
  .react-datepicker__day--selected {
    background-color: var(--color-primary);
  }
  
  .react-datepicker__day:hover {
    background-color: var(--color-primary);
  }

  .react-datepicker__month-select {
    background-color: var(--bg-surface-2);
    border-color: var(--border-light);
  }

  .react-datepicker__year-select {
    background-color: var(--bg-surface-2);
    border-color: var(--border-light);
  }

  .react-datepicker__header__dropdown {
    margin-bottom: 10px;
  }

  .react-datepicker__month-select:focus {
    border-color: var(--border-light) !important;
  }

  .react-datepicker__year-select:focus {
    border-color: var(--border-light) !important;
  }

  .react-datepicker__day--keyboard-selected {
    background-color: var(--bg-surface-2);
  }

  .react-datepicker__header {
    border-bottom: 1px solid var(--border-light) !important;
  }
`;
interface DatePickerComponentProps {
  selectedDate?: Date | null;
  onChange?: (date: Date | null) => void;
  register?: Function;
  isDateError?: boolean;
  minDate?: Date;
  placeholder?: string;
  label?: string;
  errorText?: string;
  className?: string;
  disabled?: boolean;
}

const DatePickerComponent: React.FC<DatePickerComponentProps> = ({
  selectedDate,
  onChange,
  register = () => { },
  isDateError,
  minDate,
  placeholder,
  label,
  errorText,
  className = '',
  disabled = false
}) => {
  return (
    <div className={`flex flex-col ${className}`}>
      <style>{datePickerStyles}</style>
      {label && (
        <label htmlFor="datePicker" className='text-xs text-[var(--text-muted)] mb-1'>
          {label}
        </label>
      )}
      {/* @ts-ignore */}
      <DatePicker
        selected={selectedDate}
        onChange={(date: Date | null, event: React.SyntheticEvent<any> | undefined) => {
          if (onChange) {
            onChange(date);
          }
        }}
        popperClassName="react-datepicker"
        minDate={minDate}
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        placeholderText={placeholder}
        disabled={disabled}
        className={`w-full border-none bg-transparent px-4 text-base outline-none focus:ring-0 ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'
          }`}
      />
      {isDateError && (
        <p className="text-xs text-[var(--color-error)] mt-1">{errorText}</p>
      )}
    </div>
  );
};

export default DatePickerComponent;
